import { IContentSuggestion } from '../smart-suggestion.model'

export const getIsCombinationSelected = ({
  content,
  products,
}: {
  content: IContentSuggestion[]
  products: any
}): boolean => {
  if (products.length !== content.length) {
    return false
  }

  const mapById = new Map()
  products.forEach((protection) => {
    mapById.set(protection.id, protection)
  })

  for (const item of content) {
    const correspondingObject = mapById.get(item.id)

    if (
      !correspondingObject ||
      correspondingObject.quantity !== item.quantity
    ) {
      return false
    }
  }

  return true
}
